var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSparkleBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1151 13.7109L9.61509 17.7812C9.57069 17.9008 9.49075 18.004 9.38601 18.0768C9.28127 18.1497 9.15674 18.1887 9.02915 18.1887C8.90157 18.1887 8.77704 18.1497 8.6723 18.0768C8.56755 18.004 8.48761 17.9008 8.44321 17.7812L6.94321 13.7109C6.91156 13.625 6.86164 13.547 6.79689 13.4822C6.73215 13.4175 6.65413 13.3676 6.56821 13.3359L2.4979 11.8359C2.37829 11.7915 2.27513 11.7116 2.20229 11.6068C2.12944 11.5021 2.09039 11.3776 2.09039 11.25C2.09039 11.1224 2.12944 10.9979 2.20229 10.8931C2.27513 10.7884 2.37829 10.7084 2.4979 10.664L6.56821 9.16404C6.65413 9.13238 6.73215 9.08246 6.79689 9.01772C6.86164 8.95298 6.91156 8.87495 6.94321 8.78904L8.44321 4.71873C8.48761 4.59912 8.56755 4.49596 8.6723 4.42311C8.77704 4.35026 8.90157 4.31122 9.02915 4.31122C9.15674 4.31122 9.28127 4.35026 9.38601 4.42311C9.49075 4.49596 9.57069 4.59912 9.61509 4.71873L11.1151 8.78904C11.1467 8.87495 11.1967 8.95298 11.2614 9.01772C11.3262 9.08246 11.4042 9.13238 11.4901 9.16404L15.5604 10.664C15.68 10.7084 15.7832 10.7884 15.856 10.8931C15.9289 10.9979 15.9679 11.1224 15.9679 11.25C15.9679 11.3776 15.9289 11.5021 15.856 11.6068C15.7832 11.7116 15.68 11.7915 15.5604 11.8359L11.4901 13.3359C11.4042 13.3676 11.3262 13.4175 11.2614 13.4822C11.1967 13.547 11.1467 13.625 11.1151 13.7109Z",
    stroke: "#2B6CB0",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0289 1.25V5",
    stroke: "#2B6CB0",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9039 3.125H12.1539",
    stroke: "#2B6CB0",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7789 5.625V8.125",
    stroke: "#2B6CB0",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0289 6.875H16.5289",
    stroke: "#2B6CB0",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkleBlue);
export default __webpack_public_path__ + "static/media/sparkleBlue.6089c150201dca621248bf418bd9e521.svg";
export { ForwardRef as ReactComponent };